import { jsx as _jsx, jsxs as _jsxs } from "react/jsx-runtime";
import { bemClassBuilder } from '@vista-digital/bem-class-builder';
import { observer } from 'mobx-react';
import { MemberCardNumber } from '../../card-number/member-card-number';
import { MemberMembershipStartDate } from '../../membership-start-date/member-membership-start-date';
const b = bemClassBuilder('v-member-card-membership-details');
export const MemberCardMembershipDetails = observer(props => {
    const { displayText } = props;
    return (_jsxs("div", Object.assign({ className: b.block() }, { children: [_jsx(MemberCardNumber, { displayText: { label: displayText.memberCardNumberLabel } }), _jsx(MemberMembershipStartDate, { displayText: { label: displayText.memberSinceLabel, format: displayText.memberSinceDateFormat } })] })));
});
MemberCardMembershipDetails.displayName = 'MemberCardMembershipDetails';
